import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['zh-CN', 'en', 'zh-TW'],
    fallbackLng: 'en',
    nonExplicitSupportedLngs: false,
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    debug: false,
    resources: messages,
    saveMissing: true,
    parseMissingKeyHandler: (key) => {
      console.warn(`[i18n] missing key: ${key}`);
      return key;
    },
    missingKeyHandler: (lngs, ns, key) => {
      console.warn(`[i18n] missing translation: ${key}`, { lngs, ns });
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
